module.exports = __webpack_public_path__ + "img/tag-label-icon.35313e79.svg";